import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { CustomEase } from 'gsap/CustomEase';

export default {

  init() {

    if (!$('body').hasClass('page-landing')) {
      return false;
    }

    $('.--landing .main-menu__link').click(function() {
      $('.burger').click();
    })

    gsap.registerPlugin(ScrollTrigger)


    //Parallax Splash
    gsap.to('.splash__elements__item.--cloud1', {
      yPercent: -10,
      ease: 'none',
      scrollTrigger: {
        trigger: '.splash__elements',
        start: 'top top',
        end: 'bottom top',
        scrub: true
      }
    });

    gsap.to('.splash__elements__item.--cloud2', {
      yPercent: -20,
      ease: 'none',
      scrollTrigger: {
        trigger: '.splash__elements',
        start: 'top top',
        end: 'bottom top',
        scrub: true
      }
    });

    gsap.to('.splash__elements__item.--cloud3', {
      yPercent: -50,
      ease: 'none',
      scrollTrigger: {
        trigger: '.splash__elements',
        start: 'top top',
        end: 'bottom top',
        scrub: true
      }
    });

    gsap.to('.splash__elements__item.--cloud4', {
      yPercent: -40,
      ease: 'none',
      scrollTrigger: {
        trigger: '.splash__elements',
        start: 'top top',
        end: 'bottom top',
        scrub: true
      }
    });

    gsap.to('.splash__elements__item.--cloud5', {
      yPercent: -10,
      ease: 'none',
      scrollTrigger: {
        trigger: '.splash__elements',
        start: 'top top',
        end: 'bottom top',
        scrub: true
      }
    });

    // Veggies
    const pinSections = document.querySelectorAll('.vegetables__item');
    pinSections.forEach((section, index) => {
        const imageContainer = section.querySelector('.vegetables__item__image');
        const image = imageContainer.querySelector('picture');

        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: section,
            start: "center center",
            end: "bottom top",
            pin: true,
            //anticipatePin: 1,
            scrub: 1,
          }
        });

        if ($(section).hasClass('--reverse')) {
          tl.from(imageContainer, { x: setOffScreenRight(image), duration: 3, ease: "power1.inOut", /*opacity: 0*/ });
          tl.to({}, { duration: 1 });
          tl.to(imageContainer, { x: setOffScreenLeft(image), duration: 3, ease: "power1.inOut", /*opacity: 0*/ });
        } else {
          tl.from(imageContainer, { x: setOffScreenLeft(image), duration: 3, ease: "power1.inOut", /*opacity: 0*/ });
          tl.to({}, { duration: 1 });
          tl.to(imageContainer, { x: setOffScreenRight(image), duration: 3, ease: "power1.inOut", /*opacity: 0*/ });
        }
    });

    function setOffScreenRight(el) {
      return ($(window).width() + $(el).outerWidth()) / 2;
    }

    function setOffScreenLeft(el) {
      return ($(window).width() / 2 + $(el).outerWidth()) * -1;
    }

    // Call the rotateElement function when the element enters the viewport
    ScrollTrigger.create({
      trigger: ".vegetables__end img",
      start: "top center", // When the top of the viewport reaches the center of the element
      onEnter: () => rotateElement(".vegetables__end img") // Callback function to rotate the element
    });



    // Various animations
    const sections = document.querySelectorAll(".--animate");

    sections.forEach((section) => {
      ScrollTrigger.create({
        trigger: section,
        start: "top center", // when the top of the section hits the center of the viewport
        end: "bottom center", // when the bottom of the section hits the center of the viewport
        toggleClass: "--animate-active",
        //markers: true // for visualization purposes, can be removed in production
      });
    });

    const sections2 = document.querySelectorAll(".--animate-once");

    sections2.forEach((section) => {
      ScrollTrigger.create({
        trigger: section,
        start: "top center",
        end: "bottom+=1000 top",
        toggleClass: "--animate-active",
      });
    });

    //Rotate yellow sun
    let rotateSun = gsap
      .timeline({
        scrollTrigger: {
          trigger: ".vegetables__end__sun",
          start: "top center",
          end: "bottom+=1000 top",
          invalidateOnRefresh: true
        }
      })
      .fromTo(".vegetables__end__sun",{
          scale: 1,
        },{
          scale: 1.1,
          duration: 2,
          ease: "power1.out"
        })
      .fromTo(".vegetables__end__sun",{
          rotation: 0
        },{
          rotation: 90,
          duration: 2,
          repeat: 1,
          ease: "linear"
        },0)
      .fromTo(".vegetables__end__sun",{
          rotation: 90,
        },{
          rotation: 450,
          duration: 10,
          repeat: -1,
          delay: 2,
          ease: "linear"
        },0)
      .timeScale(1);

    //services bg
    gsap.set(".services__bg__item.--cloud1", {
        yPercent: -100,
    });
    gsap.from(".services__bg__item.--cloud1", {
      yPercent: 100,
      ease: "none",
      scrollTrigger: {
        trigger: ".--services",
        start: "top bottom",
        end: "bottom top",
        scrub: true
      },
    });

    gsap.set(".services__bg__item.--cloud2", {
        yPercent: -50,
    });
    gsap.from(".services__bg__item.--cloud2", {
      yPercent: 50,
      ease: "none",
      scrollTrigger: {
        trigger: ".--services",
        start: "top bottom",
        end: "bottom top",
        scrub: true
      },
    });

    gsap.set(".services__bg__item.--cloud3", {
        yPercent: -60,
    });
    gsap.from(".services__bg__item.--cloud3", {
      yPercent: 60,
      ease: "none",
      scrollTrigger: {
        trigger: ".--services",
        start: "top bottom",
        end: "bottom top",
        scrub: true
      },
    });
  }
}
